import React from 'react';
import { Button } from 'components/ds';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Result } from 'antd';

const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Title = styled.h1`
  color: var(--header-color-background);
  font-size: var(--font-giant);
  margin-bottom: var(--spacing-small);
`;

const SubTitle = styled.p`
  color: var(--header-color-background);
  font-size: var(--font-medium);
  margin-bottom: var(--spacing-regular);
  text-align: center;
`;

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Result
        status="404"
        title={<Title>Página não encontrada</Title>}
        subTitle={
          <SubTitle>
            Desculpe, a página que você está procurando não existe ou foi removida.
          </SubTitle>
        }
        extra={
          <Button 
            type="highlight" 
            onClick={() => navigate(-1)}
            size="large"
          >
            Voltar
          </Button>
        }
      />
    </Container>
  );
};

export default NotFound; 